const loginConstant={
    LOGIN:'Login',
    NEW_USER:'New User',
    CREATE_ACCOUNT:'Create Account'
}
export default loginConstant;